import { VictoryBar, VictoryChart, VictoryAxis, VictoryTheme, VictoryStack, VictoryVoronoiContainer, VictoryTooltip, VictoryLabel } from "victory";
import { Legend } from "../charts-common.mjs";
import { responseMock, sortStackChart } from "./data.mjs";
import { YStack } from "tamagui";
import { FormatUtils, TZABrandGuidelines } from "@my/util";
import { jsx, jsxs } from "react/jsx-runtime";
const normalLabelStyle = {
  fontWeight: "normal",
  fontSize: 14
  // fontFamily: "'Prompt', sans-serif"
};
const getNormalLabelStyle = idx => ({
  ...normalLabelStyle,
  fill: TZABrandGuidelines.chartColors[idx]
});
const headerLabelStyle = {
  fontWeight: "bold",
  fill: "#A0A6A9",
  fontSize: 16,
  textAnchor: "start"
  // fontFamily: "'Prompt', sans-serif"
};
const VerticalStackChart = props => {
  const {
    sort
  } = props;
  const chartData = props.chartData ? props.chartData : responseMock;
  const getZLabel = stackNum => props?.chartZLabels[stackNum - 1] || "";
  const chart = /* @__PURE__ */jsxs(VictoryChart, {
    domainPadding: 30,
    padding: {
      top: 50,
      left: 40,
      bottom: 60,
      right: 30
    },
    theme: {
      ...VictoryTheme.material
    },
    width: 700,
    height: 400,
    containerComponent: /* @__PURE__ */jsx(VictoryVoronoiContainer, {
      voronoiDimension: "x",
      labels: props2 => {
        let stackNumber = props2.datum._stack;
        let label = `${getZLabel(props2.datum._stack)}: ${FormatUtils.currency.cashFormat(props2.datum.value, {
          decimalPlaces: 0
        })}`;
        if (stackNumber === 1) {
          label = `Priority: ${props2.datum.name}
Total: ${FormatUtils.currency.cashFormat(props2.datum.stackTotal, {
            decimalPlaces: 0
          })}
${label}`;
        }
        return label;
      },
      labelComponent: /* @__PURE__ */jsx(VictoryTooltip, {
        style: props?.chartZLabels ? [headerLabelStyle, headerLabelStyle, ...props.chartZLabels.map((_, idx) => getNormalLabelStyle(idx))] : [normalLabelStyle],
        flyoutStyle: {
          fill: "white",
          stroke: "lightgrey",
          strokeWidth: 0.5,
          filter: "drop-shadow(0px 0px 5px rgb(0 0 0 / 0.2))"
        },
        flyoutPadding: 25,
        labelComponent: /* @__PURE__ */jsx(VictoryLabel, {
          lineHeight: 1.4
        }),
        constrainToVisibleArea: true
      })
    }),
    children: [/* @__PURE__ */jsx(VictoryAxis, {
      style: {
        grid: {
          stroke: "transparent",
          strokeDasharray: "0, 0"
        },
        axis: {
          stroke: "#A0A6A9",
          strokeWidth: "1"
        },
        tickLabels: {
          fill: "#A0A6A9",
          fontFamily: "'Prompt', sans-serif"
        },
        ticks: {
          stroke: "transparent"
        }
      }
    }), /* @__PURE__ */jsx(VictoryAxis, {
      dependentAxis: true,
      tickFormat: x => x ? `${x / 1e3}k` : 0,
      style: {
        grid: {
          stroke: "#DCDFE0",
          strokeDasharray: "0, 0"
        },
        axis: {
          stroke: "transparent",
          strokeWidth: "1"
        },
        tickLabels: {
          fill: "#A0A6A9",
          fontFamily: "'Prompt', sans-serif"
        },
        ticks: {
          stroke: "transparent"
        }
      }
    }), /* @__PURE__ */jsx(VictoryStack, {
      colorScale: TZABrandGuidelines.chartColors,
      children: sortStackChart(chartData, sort, "vertical").map((data, index) => {
        const isLast = chartData.length - 1 === index;
        return /* @__PURE__ */jsx(VictoryBar, {
          barWidth: 50,
          data,
          x: "name",
          y: "value",
          cornerRadius: isLast ? {
            topLeft: 5,
            topRight: 5
          } : {}
        }, index);
      })
    })]
  });
  return /* @__PURE__ */jsxs(YStack, {
    style: {
      width: "100%",
      maxWidth: 700
    },
    children: [props?.legendData ? /* @__PURE__ */jsx(Legend, {
      legendData: props.legendData
    }) : null, chart]
  });
};
export { VerticalStackChart };
//# sourceMappingURL=VerticalStackChart.mjs.map
